import 'nprogress/nprogress.css';

import { useRouterState } from '@tanstack/react-router';
import NProgress from 'nprogress';
import { useEffect } from 'react';

import { isNativePlatform } from '@/shared/utils/platform';

NProgress.configure({
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.1,
});

const isNative = isNativePlatform();

export const NavigationProgress = () => {
  const isLoading = useRouterState({ select: s => s.status === 'pending' });

  useEffect(() => {
    if (isNative) return;

    if (isLoading) {
      NProgress.start();
    } else {
      NProgress.done();
    }
  }, [isLoading]);

  return null;
};
